import React from 'react'
import { Table } from 'antd'
import { TableRowEditButton } from '../../components/AppButton'
import FormattedBool from '../../components/FormattedBool'

class ItemListTable extends React.Component {
  render() {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
        width: 10,
        sorter: true,
      }, {
        title: 'Enable?',
        dataIndex: 'disable',
        key: 'disable',
        width: 10,
        sorter: true,
        render: bool => <FormattedBool rev bool={bool} />,
      }, {
        title: 'Title: en-US',
        dataIndex: 'title_en-US',
        key: 'title_en-US',
      }, {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 200,
        render: (text, record) => (
          <span>
            <TableRowEditButton to={`${this.props.editPath}/${record.id}`} />
            &nbsp;
            &nbsp;
            &nbsp;
            {record.use_template? <TableRowEditButton to={`${this.props.editTemplatePath}/${record.id}`} name='Template' />: ''}
          </span>
        ),
      },
    ]
    return (
      <Table
        rowKey={record => `item-row-${record.id}`}
        columns={columns}
        size='small'
        scroll={{ x: 900 }}
        {...this.props}
      />
    )
  }
}

export default ItemListTable
